<template>
  <div class="slider p-3 text-white d-flex align-items-center justify-content-center">
    <h1 class="text-center text-uppercase">Online Oktatási Felajánlások</h1>
    <div class="bg-gradient"></div>
  </div>
</template>

<script>
export default {
  name: 'Slider'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .slider {
    background: url(../assets/ivsz-slider.png) no-repeat 50% 0;
    background-size: cover;
    height: 445px;
    position: relative;
  }
  .bg-gradient {
    position: absolute;
    bottom: 0;
    left: 0;
    display: block;
    width: 100%;
    min-height: 230px;
    background: transparent url(../assets/mainbg_gradient.png) repeat-x;
  }
</style>
